import React, {Fragment, FunctionComponent, useState} from 'react'
import {Button, Icon, Item, Segment} from "semantic-ui-react";
import {FcPlus} from "react-icons/all";
import {IClientGoal} from "../../../core/models/clientGoals";
import ClientGoalDocumentForm from "../form/ClientGoalDocumentForm";
import ClientGoalSingleDocument from "./ClientGoalSingleDocument";
import moment from "moment";

interface OwnProps {
    clientGoal: IClientGoal
}

type Props = OwnProps

const ClientGoalDocuments: FunctionComponent<Props> = ({clientGoal}) => {
    
    const [addingDocumentMode, setAddingDocumentMode] = useState(false)
    
    return <Fragment>
        <Segment
            textAlign='center'
            style={{border: 'none'}}
            attached='top'
            secondary
            inverted
            color='teal'
        >
            Dokumenta
        </Segment>

        <Segment attached>
            {addingDocumentMode ?
                <ClientGoalDocumentForm 
                    clientGoalId={clientGoal.id}
                    onCancel={() => setAddingDocumentMode(false)}
                    onUploadSuccess={() => setAddingDocumentMode(false)}
                />
                : <Button
                    basic
                    icon
                    onClick={() => setAddingDocumentMode(true)}>
                    <Icon>
                        <FcPlus/>
                    </Icon>
                    Dodaj dokument
                </Button>}
            <Item.Group divided>
                {clientGoal.documents
                    .sort((a, b) => moment(a.file?.updatedAt).isBefore(b.file?.updatedAt) ? 1 : -1)
                    .map(document => <ClientGoalSingleDocument key={document.id} clientGoalDocument={document} />)}
            </Item.Group>
        </Segment>
    </Fragment>
}

export default ClientGoalDocuments
